/**
 *
 * @Copyright 2025 UNLOCKIT DECENTRALIZATION, LDA
 *
 */

import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import { WorkflowDocument } from '../../../types/workflows';
import TextBadge from '../TextBadge';
import { TranslationContext, withTranslationContext } from '../../controllers/TranslationContext';
import { TextBadgeColor } from '../../../types/textBadge';
import { ReactComponent as ClockIcon } from '../../../assets/images/clock.svg';
import { Tooltip } from '../Tooltip';

type OwnProps = TranslationContext & {
    document: WorkflowDocument;
}

const DocumentExpirationBadgeBase = (props: OwnProps) => {
    const { document, language, t } = props;

    const renderExpirationDate = () => {
        dayjs.extend(relativeTime);
        dayjs.locale(language);

        const expiringDate = dayjs(document.expiresAt);
        const diffDays = expiringDate.diff(dayjs(), 'day');
        if (diffDays > 0) {
            return t('workflows.documents.isExpiringIn', {
                dayjs: dayjs().to(document.expiresAt),
            });
        }

        if (diffDays === 0) {
            return t('workflows.documents.isExpiringToday');
        }
        
        return t('workflows.documents.expiredSince', {
            dayjs: dayjs().from(document.expiresAt),
        });
    };

    const renderExpirationDateBadgeColor = (): TextBadgeColor => {
        const expiringDate = dayjs(document.expiresAt);
        const diffDays = expiringDate.diff(dayjs(), 'day');
        if (diffDays > 90) {
            return TextBadgeColor.Gray;
        }

        if (diffDays < 0) {
            return TextBadgeColor.Red;
        }

        return TextBadgeColor.Yellow;
    };

    return (
        <Tooltip title={t('workflows.documents.expirationTooltip', {
            expiresAt: dayjs(document.expiresAt).format('DD/MM/YYYY'),
        })}
        >
            <div>
                <TextBadge text={renderExpirationDate()} icon={<ClockIcon />} color={renderExpirationDateBadgeColor()} />
            </div>
        </Tooltip>
    );
};

export const DocumentExpirationBadge = withTranslationContext(DocumentExpirationBadgeBase);
